import { useRouter } from "next/router";
import React from "react";
import SVG from "react-inlinesvg";
const BiharElectionHomeMenuBannerCard = ({
  electionKeys,
  electionPassedCategory,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath;
  // console.log("electionKeys", electionKeys?.menuList);
const menuList = electionKeys?.menuList

  // const menuList =
  //  [
  //   {
  //     title: "खबरें",
  //     src: "/assets/icons/svg/khabarSym.svg",
  //     slug: `${electionPassedCategory}`,
  //   },
  //   ...(electionKeys?.showScheduleTab
  //     ? [
  //         {
  //           title: "शेड्यूल",
  //           src: "/assets/icons/svg/calender.svg",
  //           slug: `${electionPassedCategory}/schedule`,
  //         },
  //       ]
  //     : []),
  //   ...(electionKeys?.showConstituencyTab
  //     ? [
  //         {
  //           title: "हर सीट", // "निर्वाचन क्षेत्र",
  //           src: "/assets/icons/svg/chunavSeat.svg", //"/assets/i4.gif",
  //           slug: `${electionPassedCategory}/constituency-list`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showKeyCand
  //     ? [
  //         {
  //           title: "VIP सीट", // "प्रमुख उम्मीदवार",
  //           src: "/assets/icons/svg/keycandidate.svg",
  //           slug: `${electionPassedCategory}/key-candidates-list`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showLiveUpdate
  //     ? [
  //         {
  //           title: "लाइव अपडेट्स", // "प्रमुख उम्मीदवार",
  //           src: "/assets/liveIcon.gif",
  //           slug: `${electionPassedCategory}/constituency-list#election-auto-live-blogs`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showResult
  //     ? [
  //         {
  //           title: "रिजल्ट", // "चुनाव परिणाम",
  //           src: "/assets/icons/svg/cup.svg",
  //           slug: `${electionPassedCategory}/results`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showExitPoll
  //     ? [
  //         {
  //           title: "एक्जिट पोल",
  //           src: "/assets/icons/svg/archive.svg",
  //           slug: `${electionPassedCategory}/exit-poll`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showFaqs
  //     ? [
  //         {
  //           title: `FAQs`,
  //           src: "/assets/icons/svg/faqSymbol.svg",
  //           slug: `faqs`,
  //         },
  //       ]
  //     : []),
  // ];
  return (
    <div className="mt-2 bg-white dark:bg-black border rounded-xl overflow-hidden">
      {/* Header section */}
      <div className="hidden md:flex">
        <img src= {electionKeys?.desktopBannerUrl} />
      </div>
      <div className="flex md:hidden">
        <img src= {electionKeys?.mobileBannerUrl}  />
      </div>

      {/* Scrollable horizontal menu */}
      <div className="flex gap-3 md:gap-4 py-2 px-2 border-t overflow-x-scroll scrollbar-hide bg-white dark:bg-black">
        {menuList?.map((item, index) => (
          <a
            key={item?.slug}
            href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections/${menuList[index]?.slug}`}
            target="_self"
            className={`${
              currentPath === `/${menuList[index]?.slug}` ||
              (currentPath.includes("/constituencies") &&
                menuList[index]?.slug ===
                  `elections/${electionPassedCategory}/constituency-list`)
                ? "bg-[#CF4C9B] text-white border-2 border-[#CF4C9B]"
                : "border-2 text-gray-600 hover:text-[#CF4C9B]"
            } px-3 py-1 rounded-xl whitespace-nowrap flex items-center gap-1 justify-center transition-all`}
          >
            {["/assets/liveIcon.gif", "/assets/i4.gif"]?.some((icon) =>
              item?.src?.includes(icon)
            ) ? (
              <img className="h-4 w-4" src={item?.src} alt={item?.title} />
            ) : (
              <SVG className="h-4 w-4" src={item?.src} />
            )}
            <p>{item?.title}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default BiharElectionHomeMenuBannerCard;
